
import List from "../components/List.vue";
import {
  buildBreadcrumbJsonLd,
  buildPageJsonLd,
  flatTreeData,
  findParentElements,
  getBreadList,
  getSiteOrigin,
} from "~/utils/index.js";
export default {
  asyncData({ app, route, store }) {
    const { nodeid } = route.meta[0];
    const productMenu = store.state.menu.filter(e => e.type === "products");
    const db = app.$websiteDataHelper;

    // Simplify the retrieval of hot products
    const hotProducts = db.hotProducts.slice(0, 3);

    // Simplify category retrieval and filter based on current path
    const categories = db
      .getCategories("products", nodeid)
      .sort((a, b) => a.sort * 1 - b.sort * 1);
    const path = `/${route.path.split("/")[1]}`;
    const data = categories.find(item => path === item.path)?.children || [];

    const currentPage = route.meta[0].page || 1;
    const pageSize = 12;
    const { list, count } = app.$websiteDataHelper.getList(
      "products",
      nodeid,
      currentPage,
      pageSize,
    );

    const flatArray = flatTreeData(productMenu);
    const breadList = findParentElements(route.meta[0].nodeid, flatArray);

    const productMenus = store.state.menu.filter(m => m.type === "products");
    const currentVO = app.$websiteDataHelper.getCurrentVO(productMenus, path);

    return {
      productMenu,
      pageData: list ?? [],
      banner: currentVO?.bannerurl || "/img/knowledge-page-banner.png",
      categories,
      hotProducts,
      total: count ?? 0,
      pageSize,
      currentPage,
      title: currentVO?.name_ch,
      customList: breadList,
      typeDes: currentVO?.typeDes,
      bottomTypeDes: currentVO?.bottomTypeDes,
      currentVO,
    };
  },
  head() {
    const { meta } = this.$route;
    const { menu, baseInfo, footerData } = this.$store.state;
    const siteUrl = getSiteOrigin();
    const breadList = getBreadList(menu, this.currentVO, 2);

    return {
      script: [
        {
          type: "application/ld+json",
          json: [
            buildPageJsonLd({
              route: this.$route,
              meta,
              siteUrl,
              baseInfo,
              footerData,
              includePublisher: true,
            }),
            buildBreadcrumbJsonLd(breadList),
          ],
        },
      ],
    };
  },
  components: { List },
};
